/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Row, Col, Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslator, useAppContext, formatCalories } from '@front-activerse/common-components';

const DayPlanStats = ({ meals }) => {
  const { t } = useTranslator();
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const {
    images: { infoIcon },
  } = useAppContext();

  let sumKcal = 0;
  let sumProteins = 0;
  let sumFats = 0;
  let sumCarbs = 0;

  meals.forEach((meal) => {
    sumKcal += meal.kcal;
    sumProteins += meal.macro.protein.grams;
    sumFats += meal.macro.fat.grams;
    sumCarbs += meal.macro.carbohydrates.grams;
  });

  const round = (x) => {
    return Math.round(x * 10) / 10;
  };

  return (
    <>
      <Row>
        <Col xl={{ size: 8, offset: 2 }}>
          <div className="meal-plan-stats text-center">
            <div className="position-relative">
              <p className="mb-0 small medium text-text-main-color">
                {t('mealPlan.nutritionalInfo.calories.title')}: {formatCalories(sumKcal)} kcal
              </p>

              <Button
                color="link"
                className="p-0 position-absolute top-0 end-0"
                style={{ width: '16px', height: '16px', lineHeight: '0' }}
                onClick={toggleModal}
              >
                <img src={infoIcon} alt="info" className="img-fluid" />
              </Button>
            </div>
            <hr className="my-m" />
            <Row className="divider2 text-center">
              <Col>
                <p className="mb-0 small text-text-main-color">{round(sumProteins)} g</p>
                <p className="description-small text-text-variant-color mb-0">
                  {t('mealPlan.nutritionalInfo.proteins.title')}
                </p>
              </Col>
              <Col>
                <p className="mb-0 small text-text-main-color">{round(sumFats)} g</p>
                <p className="description-small text-text-variant-color mb-0">
                  {t('mealPlan.nutritionalInfo.fats.title')}
                </p>
              </Col>
              <Col>
                <p className="mb-0 small text-text-main-color">{round(sumCarbs)} g</p>
                <p className="description-small text-text-variant-color mb-0">
                  {t('mealPlan.nutritionalInfo.carbs.title')}
                </p>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Modal isOpen={showModal} toggle={toggleModal} centered size="md">
        <ModalBody>
          <h4 className="title-medium semi-bold">{t('mealPlan.calorieBasePopup.title')}</h4>
          <p className="text-text-variant-color multi-line">
            {t('mealPlan.calorieBasePopup.content.part1')}
          </p>
          <p className="text-text-variant-color multi-line mb-0">
            {t('mealPlan.calorieBasePopup.content.part2')}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className="w-100" onClick={toggleModal}>
            {t('mealPlan.calorieBasePopup.button')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default DayPlanStats;
